module.exports = __webpack_public_path__ + "img/products_1.e5c27220.jpg";